import { StyleSheet, ViewStyle } from 'react-native';
import { Text, View } from '../Themed';
import Colors from '../../constants/Colors';

type CopyrightFooterPropsType = {
  style?: ViewStyle;
};
export default function CopyrightFooter({ style }: CopyrightFooterPropsType) {
  return (
    <View key="CopyrightFooter" style={[{ marginTop: 10, paddingTop: 10, height: 90 }, style]}>
      <View style={styles.container}>
        <View style={styles.copyrightSeparator} />
        <Text>
          Copyright 2022 PerceptionLabs, Inc.{' '}
          <a href="https://www.snapcalorie.com/terms" target="_self">
            Terms
          </a>
        </Text>
        <View style={styles.copyrightSeparator} />
      </View>
    </View>
  );
}
CopyrightFooter.defaultProps = {
  style: {},
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    alignSelf: 'stretch',
    justifyContent: 'space-around',
  },
  copyrightText: {
    textAlign: 'center',
    color: Colors.snapCalorie.textColor,
    fontSize: 12,
    fontFamily: 'Poppins, Montserrat, "Helvetica Neue", Helvetica, Arial, sans-serif;',
  },
  copyrightSeparator: {
    marginVertical: 50,
  },
});
